<template>
  <div class="sign_up_page">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 order-2 order-lg-1">
          <div class="sign_up_box">
            <h1>{{ title || $t("expired.title") }}</h1>
            <p>{{ text || $t("expired.text") }}</p>
            <hr />
            <p v-if="login" class="text-center small">
              <router-link to="/login">{{
                $t("expired.go_login")
              }}</router-link>
            </p>
            <p v-else class="text-center small">
              {{ $t("expired.need_help") }}
              <a :href="url">{{ $t("expired.support") }}</a>
            </p>
          </div>
        </div>
        <div class="col-lg-6 order-1 order-lg-2">
          <div class="key_img">
            <img
              v-if="title"
              :src="require('@/assets/static/images/auth/env-2.png')"
              alt=""
            />
            <img
              v-else
              :src="require('@/assets/static/images/auth/env.png')"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "text", "login", "supportUrl"],
  computed: {
    url() {
      if (this.supportUrl) return this.supportUrl;

      return process.env.VUE_APP_SUPPORT_PAGE &&
        process.env.VUE_APP_SUPPORT_PAGE !== "#"
        ? process.env.VUE_APP_SUPPORT_PAGE
        : "https://taskpal.com/submit-a-ticket/";
    },
  },
};
</script>
